import styled from 'styled-components'

import Util from 'helpers/Util'

const gutter = 20

const Grid = styled.div`
  padding-top: ${gutter}px;
`
const Row = styled.div`
  display: flex;
  
  &:not(:only-child) {
    padding-bottom: ${({fitted}) => fitted ? 0 : gutter}px;
  }

  ${Util.mobileOnly} {
    flex-direction: column;
  }
`

const Col = styled.div`
  ${Util.desktopOnly} {
    flex: 1 1 0;
    flex-grow: ${({width}) => width || 1};
    width: 0;

    &:not(:last-child) {
      padding-right: ${gutter}px;
    }
  }

  ${Util.mobileOnly} {
    display: ${({ desktopOnly }) => desktopOnly ? 'none' : 'block'};

    &:not(:only-child):not(:last-child) {
      padding-bottom: ${({fitted}) => fitted ? 0 : gutter}px;
    }
  }
`

Grid.Row = Row
Grid.Col = Col

export default Grid



// WEBPACK FOOTER //
// ./src/components/UI/Grid.jsx